
import qs from 'qs';

import { getXsrfHeader } from './cookies';

const headers = {
  accept: 'application/json',
  'content-type': 'application/json',
};

const ie11Headers = {
  ...headers,
  Pragma: 'no-cache',
};

const headersWithXsrf = (): HeadersInit => {
  const xsrfHeader = getXsrfHeader();
  return {
    ...headers,
    ...(xsrfHeader['X-XSRF-TOKEN'] ? xsrfHeader : {}),
  };
};

const tryParseJSON = (jsonString: string): any => {
  try {
    return JSON.parse(jsonString);
  } catch (e) {
    return jsonString;
  }
};

const parseResponseBody = (response: Response, body: any) => {
  const responseObject = tryParseJSON(body);

  if (response.ok) {
    return responseObject;
  }

  const errorMessage =
    responseObject?.error || responseObject?.message || 'Request Failed';

  throw new Error(
    [response.statusText || response.status, errorMessage].join(': '),
  );
};

//default's to send/accept 'application /json'
const commonFetch = (
  uri: string,
  body: Object,
  method: 'POST' | 'PUT' | 'PATCH' | 'DELETE',
) => {
  return fetch(uri, {
    method,
    body: JSON.stringify(body),
    headers: headersWithXsrf(),
    credentials: 'same-origin',
  });
};

const fetchThrowOnError = (
  uri: string,
  body: Object,
  method: 'POST' | 'PUT' | 'PATCH' | 'DELETE',
) => {
  return commonFetch(uri, body, method).then(response =>
    new Promise(resolve => resolve(response.text())).then(responseBody =>
      // $FlowFixMe: I don't understand flow
      parseResponseBody(response, responseBody),
    ),
  );
};

export const isIe11 = () => window.navigator.userAgent.includes('Trident');

export function get<T>(uri: string, queryParams: Object = {}): Promise<T> {
  const queryParamsString = qs.stringify(queryParams);
  return fetch(`${uri}?${queryParamsString}`, {
    method: 'GET',
    headers: isIe11() ? ie11Headers : headers,
    credentials: 'same-origin',
  }).then(response =>
    new Promise(resolve => resolve(response.text())).then(responseBody =>
      // $FlowFixMe: I don't understand flow
      parseResponseBody(response, responseBody),
    ),
  );
}

export function put(uri: string, body: Object) {
  return fetchThrowOnError(uri, body, 'PUT');
}

export function patch(uri: string, body: Object) {
  return fetchThrowOnError(uri, body, 'PATCH');
}

// 'delete' is a keyword so this needs a unique name
export function deleteFetch(uri: string, body: Object) {
  return fetchThrowOnError(uri, body, 'DELETE');
}

export function uploadFile<T>(uri: string, file: File): Promise<T> {
  const formData = new FormData();
  formData.append('file', file);
  return fetch(uri, {
    method: 'POST',
    body: formData,
    headers: getXsrfHeader(),
    credentials: 'same-origin',
  }).then(response =>
    new Promise(resolve => resolve(response.text())).then(responseBody =>
      // $FlowFixMe: I don't understand flow
      parseResponseBody(response, responseBody),
    ),
  );
}

export function post<T>(uri: string, body: Object): Promise<T> {
  return fetchThrowOnError(uri, body, 'POST');
}

export default commonFetch;
